import { MegaMenuSegment } from '@layouts/MegaMenu/MegaMenu.types';
import { apiSlice } from '@services/apiSlice';
import { Header as endpoints } from '@services/endpoints';
import { Geolocation, MegaMenuNavigation, SubNavigation, TopMenu } from './Header.types';
import { FetchBaseQueryError } from '@reduxjs/toolkit/query';
import { sortByOrder, sortColumnOrder, sortColumnSection } from './Header.utils';

interface MegaMenuNav extends MegaMenuNavigation {
  MegaMenuColumns: Record<string, MegaMenuSegment>;
}

const headerApi = apiSlice.injectEndpoints({
  endpoints: (build) => ({
    fetchMegaMenuNavigation: build.query<MegaMenuNav, void>({
      async queryFn(_arg, _queryApi, _extraOptions, fetchWithBQ) {
        let columns: Record<string, MegaMenuSegment> = {};
        const { data: megaMenuNavResponse, error: megaMenuNavError } = await fetchWithBQ({
          url: `${endpoints.fetchMegaMenuNavigation}/${window.lang}`,
        });

        if (megaMenuNavError) return { error: megaMenuNavError as FetchBaseQueryError };

        const megaMenuNav = megaMenuNavResponse as MegaMenuNavigation;

        if (megaMenuNav.MainMenuLinks) {
          const columnsResponses = await Promise.all(
            megaMenuNav.MainMenuLinks.map(async (_item, index) => {
              return await fetchWithBQ({
                url: endpoints.fetchMegaMenuColumn,
                params: { language: window.lang, index },
              });
            })
          );

          columnsResponses.forEach((response) => {
            const megaMenuSegment = response.data[0] as MegaMenuSegment;

            if (megaMenuSegment.Columns) {
              megaMenuSegment.Columns.sort(sortByOrder);
              megaMenuSegment.Columns.forEach((data) => {
                if (data.PageTypeName == 'MegaMenuOtherPage' && !data.IsOtherPageMainColumn) {
                  sortColumnSection(data);
                } else {
                  sortColumnOrder(data.ColumnAndSection);
                }
              });
            }

            columns[megaMenuSegment.ContainerLink] = megaMenuSegment;
          });
        }

        return { data: { ...megaMenuNav, MegaMenuColumns: columns } };
      },
    }),
    fetchSubNavigation: build.query<SubNavigation, void>({
      query: () => ({
        url: endpoints.fetchSubNavigation,
        params: { lang: window.lang, pageId: window.pageId },
      }),
    }),
    fetchGeolocation: build.query<Geolocation, void>({
      query: () => ({
        url: endpoints.fetchGeolocation,
        params: { language: window.lang },
      }),
    }),
    fetchTopMenu: build.query<TopMenu, void>({
      query: () => ({
        url: endpoints.fetchTopMenu + `${window.lang}/${window.pageId}`,
      }),
    }),
  }),
  overrideExisting: false,
});

export const {
  useFetchMegaMenuNavigationQuery,
  useFetchSubNavigationQuery,
  useLazyFetchGeolocationQuery,
  useFetchTopMenuQuery,
} = headerApi;
